import API from './API';
import URLSearchParams from 'url-search-params';
import ProductActions from 'actions/ProductActions';
import Moment from 'moment';

const ProductSource = {
  getRemoteProducts: {
    remote(state) {
      const fetchUrl = API.getProductList;
      let sendData = {
        first: state.first,
        maxCount: state.maxCount,
        feature_id: state.feature_id,
        type: state.type
      };
      const searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]){
          searchParams.append(k, sendData[k]);
        }
      }
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: ProductActions.fetchSuccess,
    error: ProductActions.fetchError
  },
  getRemoteProduct: {
    remote(state) {
      const fetchUrl = API.getProductDetail;
      return fetch(fetchUrl.replace(':id', state.productId)).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: ProductActions.updateProduct,
    error: ProductActions.fetchError
  },
  getRemoteTeams: {
    remote(state) {
      const fetchUrl = API.getProductTeams;
      const searchParams = new URLSearchParams();
      searchParams.append('start', Moment().format('YYYY-MM-DD'));
      return fetch(`${fetchUrl}&${searchParams}`.replace(':id', state.productId)).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: ProductActions.fetchTeamsSuccess,
    error: ProductActions.fetchError
  },
  getRemoteComments: {
    remote(state) {
      const fetchUrl = API.getProductComments;
      return fetch(fetchUrl.replace(':id', state.productId)).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: ProductActions.fetchCommentsSuccess,
    error: ProductActions.fetchError
  },
  getRemoteSlides: {
    remote(state) {
      const fetchUrl = API.getSlideList;
      const searchParams = new URLSearchParams();
      searchParams.append('tag','store');
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: ProductActions.fetchSlideSuccess,
    error: ProductActions.fetchError
  }
};

export default ProductSource;



// WEBPACK FOOTER //
// ./src/sources/ProductSource.js